import { render, staticRenderFns } from "./RoomAirVolumesComponent.vue?vue&type=template&id=65edae14&"
import script from "./RoomAirVolumesComponent.vue?vue&type=script&lang=js&"
export * from "./RoomAirVolumesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports